import { useEffect } from 'react';
import { fetchAuth } from '../utils/fetchAuth';

export function useUserPermissions(
  apiUrl: string,
  setMenuItems: (items: MenuItem[]) => void,
  setPermissions: (permissions: Permission[]) => void,
  setUser: (user: User | null) => void,
  onFinishLoading?: () => void  // <- novo callback opcional
) {

  const currentPath = window.location.pathname;
  const isHomePage = currentPath === '/' || currentPath === '/index' || currentPath === '/index.html' || currentPath === '/#';

  useEffect(() => {
    const fetchUserAndPermissions = async () => {
      try {
        const [permissionsRes, userRes] = await Promise.all([
          fetch(`${apiUrl}/contas/permissions`),
          fetchAuth(`${apiUrl}/login/verify-login`),
        ]);

        if (!permissionsRes.ok) {
          const errorData = await permissionsRes.json();
          throw new Error(errorData.message || 'Erro ao carregar permissões');
        }
        const permissionsJson = await permissionsRes.json();

        if (!userRes.ok) {
          const errorData = await userRes.json();
          throw new Error(errorData.message || 'Erro ao carregar usuário');
        }
        const userJson = await userRes.json();

        const user = userJson.user;
        setUser(user);

        const userPermission = user.permission_level;

        const activePermissions = permissionsJson.filter(
          (permission: Permission) => (userPermission & permission.code) > 0
        );
        const userPermissionNames = activePermissions.map((p: Permission) => p.name);

        const items: MenuItem[] = [
          { name: 'Home', url: isHomePage ? '/#' : '/index' },
          { name: 'Sobre Mim', url: '/#quem-sou-eu' },
          { name: 'Serviços', url: '/#servicos' },
          { name: 'Contato', url: '/#contato' },
          { name: 'Blog', url: '/blog' },
        ];

        const userNameSplit = user.name.split(' ');

        items.push({
          name: userNameSplit[0],
          children: [
            {
              name: userNameSplit[0] + ' ' + (userNameSplit.length > 1 ? userNameSplit[userNameSplit.length - 1] : ''),
              url: '/minha-conta',
              icon: '/assets/profile/no-photo.png',
              subitem: {
                name: 'Sair',
                onClick: async () => {
                  try {
                    const response = await fetchAuth(`${apiUrl}/login/logout`, {
                      method: 'POST',
                    });

                    if (!response.ok) {
                      const errorData = await response.json();
                      throw new Error(errorData.message || 'Erro ao fazer logout');
                    }

                    const responseJson = await response.json();

                    localStorage.removeItem('access_token');
                    setUser(null);
                    fetchUserAndPermissions(); // Recarrega as permissões e o usuário
                  } catch (err) {
                    console.error('Erro ao fazer logout:', err);
                  }
                }
              },
            },
            ...(userPermissionNames.includes('Administrador') ? [{ name: 'Administração', url: '/admin' }] : []),
            ...(userPermissionNames.includes('Profissional') ? [{ name: 'Consultório', url: '/consultorio' }] : []),
          ],
        });

        setMenuItems(items);
        setPermissions(activePermissions);
      } catch (err) {
        setMenuItems([
          { name: 'Home', url: isHomePage ? '/#' : '/index' },
          { name: 'Sobre Mim', url: '/#quem-sou-eu' },
          { name: 'Serviços', url: '/#servicos' },
          { name: 'Contato', url: '/#contato' },
          { name: 'Blog', url: '/blog' },
        ]);
        setPermissions([]);
        setUser(null);
      } finally {
        onFinishLoading?.(); // <- sinaliza término
      }
    };

    fetchUserAndPermissions();
  }, [apiUrl, setMenuItems, setPermissions, setUser]);
}
